import { ParcForPerimetreCAC } from './parc-for-perimetre-cac.entity';

export class AntenneForPerimetreCAC {
	id!:  number;
	nom!: string;
	parcs: ParcForPerimetreCAC[] = [];

	constructor() {
	}
}